<template>
  <!-- header -->
  <div
    id="headerWrap"
    ref="headerRef"
    :class="[
      'header',
      { on_main: transBg && !(family || open) },
      { ty_banner_on: this.showTopBanner },
    ]"
  >
    <div class="header_wrap" :class="{ open, open2: family }">
      <a
        href="#"
        class="btn_all"
        title="전체메뉴"
        @click.prevent="clickAllMenu"
      >
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </a>

      <div class="gnb_wrap" ref="gnbRef" v-show="speed !== 0">
        <ul class="gnb">
          <li
            v-for="(menu, idx) in $t('header')"
            :key="`header-${idx}`"
            :class="{ active: navMenu[idx] }"
          >
            <a href="#" @click.prevent="accoToggle(idx)">{{ menu.name }}</a>
            <SlideToggle
              v-if="menu.subs"
              tag="ul"
              selector="li"
              :duration="speed"
            >
              <li
                v-for="(sub, sidx) in menu.subs"
                :key="`header-${idx}-${sidx}`"
                :class="{
                  //depth2: sub.tabs,
                  active: sub.tabs && sub3depth[idx][sidx],
                }"
              >
                <router-link :to="{ path: sub.path }">{{
                  sub.name
                }}</router-link>
                <!-- <a
                  href="#"
                  v-if="sub.tabs"
                  @click.prevent="clickDepth3(idx, sidx)"
                  >{{ sub.name }}</a
                >
                <router-link v-else :to="{ path: sub.path }">{{
                  sub.name
                }}</router-link> -->
                <!-- <SlideToggle
                  tag="div"
                  selector="a"
                  v-if="sub.tabs"
                  :duration="speed"
                > -->
                <!--a
                    v-for="(tab, tidx) in sub.tabs"
                    :href="`${tab.path}?${tidx}${tab.hash}`"
                    :key="`header-${idx}-${sidx}-${tidx}`"
                    >{{ tab.name }}</a
                  -->
                <!-- <router-link
                    v-for="(tab, tidx) in sub.tabs"
                    :to="{ path: tab.path, hash: tab.hash }"
                    :key="`header-${idx}-${sidx}-${tidx}`"
                    >{{ tab.name }}</router-link
                  >
                </SlideToggle> -->
              </li>
            </SlideToggle>
          </li>
        </ul>
      </div>

      <h1 v-if="this.isMain">
        <a :href="$t('main[0].path')"></a>
      </h1>

      <div class="sub_2depth" v-if="!this.isMain && this.page.length">
        <div class="div_label" :class="{ active: sub2depth }">
          <a href="#" @click.prevent="sub2depthToggle">{{ subDepthTit }}</a>
        </div>
        <!--// 메뉴 선택시 .active 추가 -->
        <ul ref="subListRef">
          <li v-for="sub in sub2depthInit" :key="sub.name">
            <router-link :to="{ path: sub.path }">
              {{ sub.name }}
            </router-link>
          </li>
        </ul>
      </div>
      <!-- <a href="#" class="btn_family" @click.prevent="clickFamily"
        ><div class="petal_wrap">
          <span class="petal"></span><span class="petal"></span
          ><span class="petal"></span><span class="petal"></span></div
      ></a> -->
      <div class="family_wrap">
        <em>FAMILY COMPANY</em>
        <ul>
          <li>
            <a
              :href="$t('footer.select[0].options[0].path')"
              title="새 창으로 이동"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div class="img_wrap">
                <img :src="`${resources}/img/img_family01.png`" alt="" />
              </div>
              <strong>금융, 도시가스, 건설</strong>
              <p>인류를 위해 더 나은 세상을 만들어 나갑니다.</p>
            </a>
          </li>
          <li>
            <a
              :href="$t('footer.select[0].options[1].path')"
              title="새 창으로 이동"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div class="img_wrap">
                <img :src="`${resources}/img/img_family02.png`" alt="" />
              </div>
              <strong>도시가스</strong>
              <p>따뜻함과 행복을 드리는 생활에너지기업</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!--div
      class="dropdown-wrapper"
      @mouseover="toggleLang"
      @mouseleave="toggleLang"
    >
      <button>Languages</button>
      <ul ref="selectLocale" class="nav-dropdown">
        <li>
          <button @click="changeLanguage('ko')">
            한국어
          </button>
        </li>
        <li>
          <button @click="changeLanguage('en')">
            english
          </button>
        </li>
      </ul>
    </div-->
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { get } from 'lodash-es';
import mixin from '@/mixins';
import SlideToggle from '@/components/SlideToggle';

/**
 * @module components/mo/Top
 * @vue-data {Boolean} sub2depth=false - 서브 페이지 메뉴 상태 값
 * @vue-data {Array} sub3depth=Array - 햄버거 메뉴 3depth 상태 값
 * @vue-data {Number} st=0 - 브라우저 스크롤 세로 위치
 * @vue-data {Number} speed=0.3 - 애니메이션 속도
 * @vue-computed {Boolean} showTopBanner - 탑 배너 체크
 * @vue-computed {Boolean} isMain - 메인인지 유무
 * @vue-computed {Object} page - 페이지 정보
 * @vue-computed {Array} navMenu - 햄버거 메뉴 상태 값
 * @vue-computed {Boolean} open - 열림 유무
 * @vue-computed {Boolean} family - 패밀리 영역 열림 유무
 * @vue-computed {Number} scrollTop=0 - 브라우저 스크롤 세로 위치
 * @vue-computed {Boolean} transBg - 투명 bg 유무
 * @vue-computed {Boolean} sub2depthInit - 서브 페이지 메뉴 구성
 * @vue-computed {String} subDepthTit - 페이지 타이틀 값
 */
export default {
  components: {
    SlideToggle
  },
  data() {
    return {
      sub2depth: false,
      sub3depth: Array.from(Array(this.$t('header').length), () =>
        Array(() => {
          this.$t('header').forEach((el) => {
            let maxSize = 0;
            const subLen = el.subs.length;
            if (maxSize < subLen) {
              maxSize = subLen;
            }
            return maxSize;
          });
        }).fill(false)
      ),
      st   : 0,
      speed: 0.3
    };
  },
  mixins  : [mixin],
  computed: {
    ...mapState('main', {
      showTopBanner: 'showTopBanner',
      isMain       : 'is'
    }),
    ...mapState('view', {
      page     : 'page',
      navMenu  : 'navMenu',
      open     : (state) => state.header.open,
      family   : (state) => state.header.family,
      scrollTop: 'scrollTop'
    }),
    transBg() {
      return this.isMain && this.st === 0;
    },
    sub2depthInit() {
      let menu = false;
      this.$t('header').forEach((el) => {
        el.subs.forEach((con) => {
          if (con.name === get(this.page, '[1]name')) {
            menu = el.subs;
          }
        });
      });
      return menu;
    },

    subDepthTit() {
      return get(this.page, '[1]name', '');
    }
  },
  mounted() {
    this.$nextTick(() => {
      // const { height } = this.$refs.headerRef.getBoundingClientRect();
      // this.setHeaderHeight(height);
      this.pageCheck();
    });
    this.mainCheck();
  },
  watch: {
    $route() {
      this.speed = 0;
      this.mainCheck();

      this.$nextTick(() => {
        this.pageCheck();
        setTimeout(() => {
          this.speed = 0.3;
        }, 10);
      });
    },
    scrollTop(value) {
      this.st = value;
    }
  },
  methods: {
    ...mapMutations('view', {
      setHeaderOpen  : 'SET_HEADER_OPEN',
      setHeaderHeight: 'SET_HEADER_HEIGHT',
      setHeaderFamily: 'SET_HEADER_FAMILY',
      setMenuRefresh : 'SET_MENU_REFRESH'
    }),
    ...mapMutations('main', {
      setShowTopBanner: 'SET_SHOW_TOP_BANNER'
    }),
    /**
     * 햄버거 메뉴 클릭 이벤트
     */
    clickAllMenu() {
      this.sub2depthToggle(false);
      this.setHeaderOpen(!this.open);
      this.setHeaderFamily(false);
    },
    /**
     * 패밀리 메뉴 클릭 이벤트
     */
    clickFamily() {
      this.setHeaderFamily(!this.family);
    },
    /**
     * 3depth 클릭 이벤트
     * @param {Number} idx 2depth 인덱스
     * @param {Number} sidx 3depth 인덱스
     */
    clickDepth3(idx, sidx) {
      this.$set(this.sub3depth[idx], [sidx], !this.sub3depth[idx][sidx]);
    },
    /**
     * 서브 페이지 메뉴 토글 이벤트
     * @param {Boolean} status on/off 유무
     */
    sub2depthToggle(status) {
      const subListRef = this.$refs.subListRef;
      let stat = typeof status === 'boolean' ? status : !this.sub2depth;

      if (!this.isMain && subListRef !== undefined) {
        if (stat) {
          if (this.open) {
            this.setHeaderOpen(false);
          }
          subListRef.style.marginTop = '0';
          this.sub2depth = true;
        } else {
          this.sub2depth = false;
          subListRef.style.marginTop = -100 + '%';
        }
      }
    },
    /**
     * 햄거버 메뉴 아코디언 토글
     * @param {Number} 토글 컨텐츠 인덱스
     */
    accoToggle(index) {
      const arr = [];
      this.navMenu.forEach((el, arrIdx) => {
        arr[arrIdx] = el;
        if (index === arrIdx) {
          arr[arrIdx] = !el;
        }
      });
      this.setMenuRefresh(arr);
    },
    /**
     * 메인 체크 후 탑 배너 처리
     */
    mainCheck() {
      if (this.isMain === false) {
        this.setShowTopBanner(false);
      }
    },
    /**
     * 페이지 로드 후 메뉴 위치 및 상태 값 초기화
     */
    pageCheck() {
      this.setHeaderOpen(false);
      this.sub2depthToggle(false);
      let arr = new Array(this.navMenu.length).fill(false);
      arr[get(this.page, '[0]idx')] = true;
      this.setMenuRefresh(arr);

      // if (get(this.page, '[1]tabs') !== undefined) {
      //   this.$set(
      //     this.sub3depth[get(this.page, '[0]idx')],
      //     [get(this.page, '[1]idx')],
      //     true
      //   );
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.header_wrap .gnb_wrap .gnb li {
  min-width: 100vw;
}
.header_wrap .gnb_wrap .gnb > li ul {
  display: block;
  overflow: hidden;
  transition: all var(--s) ease-out;
  height: 0;
}

.header_wrap .gnb_wrap .gnb > li.active ul {
  height: var(--h);
}

.header .gnb > li > ul > li.depth2 > div {
  display: block;
  overflow: hidden;
  transition: all var(--s) ease-out;
  height: 0;
}

.header .gnb > li > ul > li.depth2.active > div {
  height: var(--h);
}

.sub_2depth {
  ul {
    margin-top: -100%;
    height: auto;
  }
}
</style>
